<template>
    <div class="flex items-center justify-between order-product mb-4">
        <template v-if="row.type === 'comment'">
            <div class="flex-1 relative mr-2">
                <TextInput
                    v-model="row.comment"
                    name="comment"
                    v-validate="'required'"
                    type="text"
                    :error="formErrors.first('comment')"
                />
            </div>
        </template>
        <template v-else>
            <div class="flex-1 relative mr-2">
                <SearchProductInput
                    v-model="row.product"
                    v-validate="'required'"
                    :pre-selected="row.product"
                    name="product"
                    :error="formErrors.first('product')"
                    @setProduct="setProduct"
                />
                <input
                    v-model="row.product_name"
                    type="hidden"
                >
                <input
                    v-model="row.product_id"
                    type="hidden"
                >
            </div>
            <div class="flex items-center" v-if="row.product_unit_id === 4">
                <div class="w-24">
                    <TextInput
                        v-model="row.width"
                        name="width"
                        v-validate="'required'"
                        type="text"
                        placeholder="Breedte"
                        :error="formErrors.first('width')"
                    />
                </div>
                <div class="ml-2 mr-2">x</div>
                <div class="w-24 mr-2">
                    <TextInput
                        v-model="row.height"
                        name="height"
                        v-validate="'required'"
                        type="text"
                        placeholder="Hoogte"
                        :error="formErrors.first('height')"
                    />
                </div>
            </div>
            <div v-else class="w-48 mr-2">
                <TextInput
                    v-model="row.product_sku"
                    name="product_sku"
                    v-validate="'required'"
                    type="text"
                    :error="formErrors.first('product_sku')"
                />
            </div>
            <div class="w-32 mr-2">
                <NumberInput
                    v-model="row.quantity"
                    v-validate="'required'"
                    name="quantity"
                    type="text"
                    :error="formErrors.first('quantity')"
                    @input="updateQuantity(row)"
                />
            </div>
            <div class="w-32 mr-2">
                <TextInput
                    v-model="row.sales_price"
                    v-validate="'required'"
                    name="sales_price"
                    type="text"
                    :error="formErrors.first('sales_price')"
                    @input="updateSalesPrice(row)"
                />
            </div>
            <div class="w-32">
                <input v-model="row.total_price" type="hidden">
                <Price :amount="row.total_price" />
            </div>
        </template>
        <div class="w-24">
            <button @click.prevent="removeRow(row)"><Icon name="x-circle" /></button>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';

    import Price from '@/components/Price';
    import SearchProductInput from '@/components/inputs/SearchProductInput';
    import TextInput from '@/components/inputs/TextInput';
    import NumberInput from '@/components/inputs/NumberInput';

    export default {
        name: 'OrderRow',
        components: {
            Price,
            SearchProductInput,
            NumberInput,
            TextInput,
        },
        props: {
            row: {
                type: Object,
                required: true,
            },
            index: {
                type: Number,
                required: true,
            },
        },
        methods: {
            ...mapActions('order', [
                'removeRow',
            ]),

            setProduct(product) {
                if (!product) return;

                this.row.product_id = product.id;
                this.row.product_name = product.name;
                this.row.product_sku = product.sku;
                this.row.product_unit_id = product.product_unit_id;
                this.row.product = { id: product.id, name: product.name };
                this.row.options = product.product_unit_id === 4 ? {
                    height: null,
                    width: null,
                } : {};
                this.row.sales_price = product.sales_price;
                this.row.total_price = product.sales_price * this.row.quantity;
            },

            updateQuantity(row) {
                row.quantity = row.quantity.replace(/,/g, '.');
                row.total_price = row.sales_price * row.quantity;
            },

            updateSalesPrice(row) {
                row.sales_price = row.sales_price.replace(/,/g, '.');
                row.total_price = row.sales_price * row.quantity;
            },
        },
    };
</script>
